import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import IconButton from '@material-ui/core/IconButton';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import LastPageIcon from '@material-ui/icons/LastPage';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import cx from 'classnames';

export interface CustomPaginationProps {
  totalPage: number;
  currPage: number;
  onChange: (value: number) => void;
}

const CustomPagination = ({ totalPage, currPage, onChange }: CustomPaginationProps) => {
  const [pageList, setPageList] = useState<number[]>([]);
  const [listStart, setListStart] = useState<number | null>(null);
  const [listEnd, setListEnd] = useState<number | null>(null);
  const [isStartPage, setIsStartPage] = useState<boolean>(false);
  const [isEndPage, setIsEndPage] = useState<boolean>(false);

  useEffect(() => {
    // const curr = Math.trunc(currPage / 10);
    const curr = Math.trunc((currPage - 1) / 10); //1~10페이지 몫 0으로 맞추기
    const listStartVal = curr * 10 + 1;
    const listEndVal = listStartVal + 9 > totalPage ? totalPage : listStartVal + 9;
    setListStart(listStartVal);
    setListEnd(listEndVal);
    setIsStartPage(listStartVal == 1);
    setIsEndPage(totalPage == listEndVal);
  }, [totalPage, currPage]);

  useEffect(() => {
    if (!!listStart && !!listEnd) {
      setPageList([]);
      for (let i = listStart; i <= listEnd; i++) {
        setPageList(draft => [...draft, i]);
      }
    }
  }, [listStart, listEnd, currPage]);

  return (
    <Styled.CustomPagination data-component-name="CustomPagination">
      <ul className="customPagination__container">
        <li className="customPagination__list_item">
          <IconButton
            className="customPagination__item first"
            disabled={isStartPage}
            onClick={() => {
              onChange(1);
            }}
          >
            <FirstPageIcon />
          </IconButton>
        </li>
        <li className="customPagination__list_item">
          <IconButton
            className="customPagination__item prev"
            disabled={isStartPage}
            onClick={() => {
              if (!listStart) return;
              // const prevPage = listStart - 10;
              const prevPage = listStart - 1;
              onChange(prevPage);
            }}
          >
            <NavigateBeforeIcon />
          </IconButton>
        </li>

        {pageList.length > 0 &&
          pageList.map((item: number) => {
            return (
              <li className="customPagination__list_item" key={item}>
                <IconButton
                  className={cx('customPagination__item page', {
                    curr: currPage === item,
                  })}
                  onClick={() => {
                    onChange(item);
                  }}
                >
                  {item}
                </IconButton>
              </li>
            );
          }, [])}
        <li className="customPagination__list_item">
          <IconButton
            className="customPagination__item next"
            disabled={isEndPage}
            onClick={() => {
              if (!listEnd) return;
              const nextPage = listEnd + 1;
              onChange(nextPage);
            }}
          >
            <NavigateNextIcon />
          </IconButton>
        </li>
        <li className="customPagination__list_item">
          <IconButton
            className="customPagination__item last"
            disabled={isEndPage}
            onClick={() => {
              onChange(totalPage);
            }}
          >
            <LastPageIcon fontSize="inherit" />
          </IconButton>
        </li>
      </ul>
    </Styled.CustomPagination>
  );
};

const Styled = {
  CustomPagination: styled.div<{}>`
    .customPagination__container {
      display: flex;
      list-style: none;
      align-items: center;
      justify-content: center;
      .customPagination__item {
        width: 32px;
        height: 32px;
        padding: 0;
        font-weight: 300;
        &.page {
          font-size: 16px;
          color: #4a4a4a;
          &.curr {
            color: #33b5e4;
          }
        }
        &:not(.page) {
          font-size: 24px;
        }
      }
    }
  `,
};

export default React.memo(CustomPagination);
